import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDropdownComponent } from './user-dropdown.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  imports: [
    CommonModule,
    InfiniteScrollModule,
    ReactiveFormsModule
  ],
  declarations: [
    UserDropdownComponent
  ],
  exports:[
    UserDropdownComponent
  ]
})
export class UserDropdownModule { }



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/user-dropdown/user-dropdown.module.ts